import { Box, MenuItem, Select, SelectProps } from '@mui/material';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { imageSrcByMaterial } from 'boardCanvas/Materials';
import { Material, Materials } from 'Types';

function MaterialSelector(
  props: Omit<SelectProps<Material>, 'onChange'> & {
    onChange: (material: Material) => void;
  }
) {
  const { onChange, value, ...restProps } = props;

  const _onChange: SelectInputProps<Material>['onChange'] = (event) => {
    onChange(event.target.value as Material);
  };

  return (
    <Select {...restProps} value={value} onChange={_onChange}>
      {Materials.map((material) => (
        <MenuItem key={material} value={material}>
          <Box sx={{ display: 'inline', mr: 1 }}>
            <img
              src={imageSrcByMaterial[material]}
              alt={material}
              height={16}
              width={16}
            />
          </Box>
          {material}
        </MenuItem>
      ))}
    </Select>
  );
}

export default MaterialSelector;
